export default {
  addParentToList (state, payload) {
    state.parentInfo = payload.parentInfo
  },
  getParentInfo (state, payload) {
    state.parentInfo = Object.assign({}, payload.parentInfo)
    if (state.parentInfo.partner_info == null) {
      state.parentInfo.partner_info = {
        name: "",
        furigana: "",
        romaji: "",
        address_1: "",
        address_2: "",
        email: "",
        phone: "",
        gender: 0
      }
    }
  },
  goToPage (state, payload) {
    state.searchData = payload
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }

}
